import { backendHttpClient } from "app/utils/axios";

export const verifyCaptcha = async (captchaToken, accessToken) => {
  const captchaData = await backendHttpClient
    .post(
      "/captcha/recaptcha-siteverify/",
      { response: captchaToken },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    .then((res) => {
      return res?.data;
    });

  return captchaData;
};
